import React, { useCallback, useContext, useEffect, useState } from 'react';
import '../../../libs/bulma.min.css';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPhoneSquare } from '@fortawesome/free-solid-svg-icons';

function FormIPInterfaces(props) {
  const { iface, data, handleChangeValues } = props;
  const metrics = [ 1, 100, 200, 300 ];

  return (
    <div name="change-ip-div" className="is-align-content-center">
      <div className="columns mx-1">
        
      <div className="column mt-5 pt-4 is-full is-1 is-offset-1 mr-5 has-text-centered">
          <label className="label">
            <div className="control">
            <button className="button is-fullwidth is-primary px-6 mx-2" >
              <span>
                <p className='px-2 is-size-5 is-uppercase'>{ iface.includes('_') ? iface.split('_').join('.') : iface }</p>
              </span>
            </button>
            </div>
          </label>
        </div>
        <div className="column is-2 field mt-2 my-2">
          <label className="label">IP
            <div className="control">
              <input className="input" name={`${iface}-ip`} type="text" placeholder="1.1.1.2" onBlur={(e) => handleChangeValues(e.target)} />
              <p name={`${iface}-ip-invalid-data`} className='has-text-danger is-size-7 is-hidden'>Caracteres inválidos!</p>
            </div>
          </label>
        </div>
        <div className="column is-2 field mt-2">
          <label className="label">Máscara
            <div className="control">
              <input className="input" name={`${iface}-mask`} type="text" placeholder="255.255.255.0" onBlur={(e) => handleChangeValues(e.target)} />
              <p name={`${iface}-mask-invalid-data`} className='has-text-danger is-size-7 is-hidden'>Caracteres inválidos!</p>
            </div>
          </label>
        </div>
        <div className="column is-2 field mt-2">
          <label className="label">Gateway
            <div className="control">
              <input className="input" name={`${iface}-gw`} type="text" placeholder="1.1.1.1" onBlur={(e) => handleChangeValues(e.target)} />
              <p name={`${iface}-gw-invalid-data`} className='has-text-danger is-size-7 is-hidden'>Caracteres inválidos!</p>
            </div>
          </label>
        </div>
        <div className="column is-2 field mt-2">
          <label className="label">Métrica
            <div className="control">
              <div name="transport" className="select is-fullwidth">
                <select className="select" name={`${iface}-metric`} onChange={(e) => handleChangeValues(e.target)} >
                  <option value="">Selecione</option>
                    {metrics.map((metric) => <option key={metric} value={metric}>{ metric }</option>)}
                </select>
                <p name={`${iface}-metric-invalid-data`} className='has-text-danger is-size-7 is-hidden'>Caracteres inválidos!</p>
              </div>
            </div>
          </label>
        </div>
      </div>
    </div>
  );
}

export default FormIPInterfaces;
